import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {HttpClientService} from './http-client.service';

@Injectable()
export class AuthService implements CanActivate {


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

        const that = this;
        let user = localStorage.getItem('mea_user');
        let token = localStorage.getItem('mea_token');

        if (route.params['user'] && route.params['token']) {
            user = route.params['user'];
            token = route.params['token'];
        }

        if (user && token) {

            localStorage.setItem('mea_user', user);
            localStorage.setItem('mea_token', token);

            const promise = new Promise<boolean>((resolve, reject) => {
                that.http.post('checklogin', {user: user, token: token})
                    .subscribe((result) => {
                        if (result['token'] === 'match') {
                            resolve(true);
                        } else {
                            localStorage.removeItem('mea_user');
                            localStorage.removeItem('mea_token');
                            resolve(false);
                        }
                    }, (error) => {
                        localStorage.removeItem('mea_user');
                        localStorage.removeItem('mea_token');
                        window.location.href = 'https://www.akceso.ch/get-resources-eIRP-impact-tool-login.php?auth=failed';

                    });
                resolve(true);
            });

            return promise;
        }

        window.location.href = 'https://www.akceso.ch/get-resources-eIRP-impact-tool-login.php?auth=failed';

    }

    constructor(private http: HttpClientService) {
        console.log(http);
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/services/auth.service.ts